import { useState } from 'react';

export const useTableGrouping = () => {
  const [groupingPopoverVisible, setGroupingPopoverVisible] = useState<boolean>(false);
  const handleShow = () => setGroupingPopoverVisible(!groupingPopoverVisible);

  return { groupingPopoverVisible, handleShow };
};

